module.exports = __webpack_public_path__ + "static/media/MemberCardBack.19886f42.png";